import { useTheme } from '@mui/material'

const CalendarIcon = () => {
  const theme = useTheme()

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4H6V3H14V4H16V3H18V6H2V3H4V4ZM2 8V18H18V8H2ZM6 1H14V0H16V1H18C19.1046 1 20 1.89543 20 3V18C20 19.1046 19.1046 20 18 20H2C0.89543 20 0 19.1046 0 18V3C0 1.89543 0.89543 1 2 1H4V0H6V1Z"
        fill={theme.palette.custom.darkBlue2}
      />
    </svg>
  )
}

export { CalendarIcon }
